










































































































import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { formatYearsMonthDay } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { IClearance, Clearance } from "@/models/clearance.entity";
import { IInvoiceParty, InvoiceParty } from "@/models/invoice-party.entity";
import { IReport } from "@/models/report.entity";
import { IReference } from "@/models/reference.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import PreselectTemplateCard from "../partner/PreselectTemplateCard.vue";
import LineItemsForm from "../repair-estimate/LineItemsForm.vue";
import RepairEstimatePartyForm from "../repair-estimate/RepairEstimatePartyForm.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import RefsClearance from "../utility/RefsClearance.vue";
import RefsClearanceApproval from "@/components/utility/RefsClearanceApproval.vue";
import SelectAssignees from "../utility/SelectAssignees.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";

export enum ClearanceApprovalCreateClearanceDialogStepEnum {
  CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL = "confirmDeriveFromEstimate",
  SELECT_APPROVER = "selectApprover",
  ENTER_TITLE = "enterTitle",
  SUCCESS = "success",
  SEND_MAIL_FOR_CLEARANCE = "sendMailForClearance"
}

@Component({
  components: {
    ConfirmActionDialog,
    SelectAssignees,
    RepairEstimatePartyForm,
    LineItemsForm,
    PreselectTemplateCard,
    RefsClearance,
    RefsClearanceApproval
  }
})
export default class ClearanceApprovalCreateClearanceDialog extends mixins(PartnerFallbackMixin, RulesMixin)
  implements IDialog {
  readonly ClearanceApprovalCreateClearanceDialogStepEnum = ClearanceApprovalCreateClearanceDialogStepEnum;
  readonly ResourceEnum = ResourceEnum;
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Prop()
  partnerId!: string;

  @Prop()
  refs!: IReference[];

  @Prop()
  hideButton!: boolean;

  @Prop()
  repairEstimate?: IRepairEstimate;

  @Prop()
  clearanceApprovals!: IClearanceApproval[];

  @Prop()
  report?: IReport;

  isDialogActive = false;

  allCreated: IClearance[] = [];

  step: ClearanceApprovalCreateClearanceDialogStepEnum =
    ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL;

  buyer: IInvoiceParty | undefined;

  seller = new InvoiceParty();

  repairStart: string | undefined = undefined;

  repairEnd: string | undefined = undefined;

  deriveResponse: boolean | null = null;

  isLoading = false;

  sharedContent: ISharedContent | null = null;

  clearance: IClearance | null = null;

  clearanceTitle = "";

  createdClearance: IClearance | null = null;

  get attachmentFileFilters() {
    return this.report?.refFilter || [];
  }

  get to() {
    return this.clearance?.seller ? [this.clearance.seller.email] : [];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context() {
    return {
      repairEstimate: this.repairEstimate,
      clearanceApproval: this.clearanceApprovals[0],
      clearance: this.clearance,
      sharedContent: this.sharedContent,
      partner: this.partner,
      report: this.report,
      vehicle: this.clearanceApprovals[0]?.report?.vehicle,
      url: { sharing: this.sharedContent?.url ?? "" }
    };
  }

  /** Invoice date */
  get repairStartFormable(): string {
    if (!this.repairStart) {
      return "";
    }
    return formatYearsMonthDay(new Date(this.repairStart));
  }

  set repairStartFormable(date: string) {
    if (date) {
      this.repairStart = new Date(date).toISOString();
    } else {
      this.repairStart = undefined;
    }
  }

  /** Invoice date */
  get repairEndFormable(): string {
    if (!this.repairEnd) {
      return "";
    }
    return formatYearsMonthDay(new Date(this.repairEnd));
  }

  set repairEndFormable(date: string) {
    if (date) {
      this.repairEnd = new Date(date).toISOString();
    }
  }

  get user() {
    return UserModule.user;
  }

  get stepTitle(): string {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        return $t("clearanceApproval.clearanceDialog.confirm.title");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER:
        return $t("clearanceApproval.clearanceDialog.approver.select");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SEND_MAIL_FOR_CLEARANCE:
        return $t("clearanceApproval.clearanceDialog.notification.title");
      case ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE:
        return $t("clearanceApproval.clearanceDialog.title.label");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        return $t("clearanceApproval.clearanceDialog.success.title");
      default:
        return $t("clearanceApproval.createClearanceOrApproval");
    }
  }

  // Dynamic subtitle based on current step
  get stepSubtitle(): string | undefined {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        return $t("clearanceApproval.clearanceDialog.confirm.subtitle");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER:
        return $t("clearanceApproval.clearanceDialog.approver.subtitle");
      case ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE:
        return $t("clearanceApproval.clearanceDialog.title.subtitle");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        return "";
      default:
        return undefined;
    }
  }

  // Dynamic right button text
  get rightButtonText(): string {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        return $t("yes");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SEND_MAIL_FOR_CLEARANCE:
        return $t("clearanceApproval.clearanceDialog.notification.send");
      case ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE:
        return $t("create");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        return $t("view");
      default:
        return $t("next");
    }
  }

  get leftButtonText(): string {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        return $t("no");
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        return $t("Fertig");
      default:
        return $t("back");
    }
  }

  get isRightButtonDisabled(): boolean {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        return false;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER:
        return this.seller.ref?.refId ? false : true;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SEND_MAIL_FOR_CLEARANCE:
        return this.isLoading;
      case ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE:
        return !this.clearanceTitle.trim();
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        return false;
      default:
        return false;
    }
  }

  open() {
    this.isDialogActive = true;
    this.resetDialogState();
    this.allCreated.splice(0);
    this.seller = this.repairEstimate?.seller ?? new InvoiceParty();

    this.onReportIdChange();
  }

  @Watch("clearance.reportId")
  async onReportIdChange() {
    await this.clearance?.fetchReportAndVehicle().catch(this.$log.error);
  }

  close() {
    this.isDialogActive = false;
    this.resetDialogState();
    this.$emit("close");
  }

  resetDialogState() {
    this.step = ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL;
    this.deriveResponse = null;
    this.isLoading = false;
    this.clearanceTitle = "";
    this.repairStart = undefined;
    this.repairEnd = undefined;
    this.createdClearance = null;
    this.isLoading = false;
    this.sharedContent = null;
    this.clearance = null;
  }

  async onRightClick() {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        this.deriveResponse = true;
        this.buyer = this.clearanceApprovals[0].buyer;
        this.step = ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER;
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER:
        this.step = ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE;
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SEND_MAIL_FOR_CLEARANCE:
        await this.sendMailForClearance();
        this.step = ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS;
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE:
        await this.createClearance();
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        this.clearance?.goTo(this.$router).detail();
        this.close();
        break;
    }
  }

  onLeftClick() {
    switch (this.step) {
      case ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL:
        this.close();
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER:
        this.step = ClearanceApprovalCreateClearanceDialogStepEnum.CONFIRM_DERIVE_FROM_CLEARANCE_APPROVAL;
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SEND_MAIL_FOR_CLEARANCE:
        this.step = ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE;
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.ENTER_TITLE:
        this.step = ClearanceApprovalCreateClearanceDialogStepEnum.SELECT_APPROVER;
        break;
      case ClearanceApprovalCreateClearanceDialogStepEnum.SUCCESS:
        this.close();
        break;
    }
  }

  async sendMail() {
    try {
      this.isLoading = true;
      await (this.$refs.templateCard as PreselectTemplateCard)?.send();
      await this.clearanceApprovals[0]
        ?.updatePartial({
          status: RequestStatusEnum.REQUESTED
        })
        .catch(handleError);
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  async sendMailForClearance() {
    try {
      this.isLoading = true;
      await (this.$refs.templateCard as PreselectTemplateCard)?.send();
      await this.clearance
        ?.updatePartial({
          status: RequestStatusEnum.REQUESTED
        })
        .catch(handleError);

      await this.clearance?.updatePartial({
        status: RequestStatusEnum.REQUESTED
      });
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }

  async createClearance() {
    try {
      const refs = this.clearanceApprovals[0]?.refs || [];
      this.isLoading = true;
      this.clearance = await new Clearance({
        partnerId: this.partnerId,
        refs: refs || [],
        assignees: this.clearanceApprovals[0].assignees,
        buyer: this.buyer,
        seller: this.seller,
        estimateId: this.repairEstimate?.id,
        reportId: this.report?.id,
        clearanceApprovalIds: this.clearanceApprovals.map(c => c.id),
        lineItems: this.clearanceApprovals[0].lineItems,
        status: RequestStatusEnum.REPLIED,
        title: this.clearanceTitle,
        repairEnd: this.repairEnd,
        repairStart: this.repairStart
      }).create();

      this.allCreated.push(this.clearance);

      const clearanceRef = { refId: this.clearance.id, refType: ResourceEnum.CLEARANCE };

      await this.repairEstimate?.updatePartial({
        refs: [...(this.repairEstimate.refs ?? []), { refId: this.clearance.id, refType: ResourceEnum.CLEARANCE }]
      });
      for (const clearanceApproval of this.clearanceApprovals) {
        await clearanceApproval.updatePartial({
          refs: [...(clearanceApproval.refs ?? []), clearanceRef]
        });
      }

      const sharedRefs = [clearanceRef];
      if (this.report?.id) {
        sharedRefs.push({ refId: this.report?.id, refType: ResourceEnum.REPORT });
      }

      this.sharedContent = await new SharedContent({
        partnerId: this.partnerId,
        refs: sharedRefs
      }).create();

      this.step = ClearanceApprovalCreateClearanceDialogStepEnum.SEND_MAIL_FOR_CLEARANCE;
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
